import React, { useEffect, useState } from "react";
import Slider from "react-slick";

interface SlideItem {
  heading: string;
  text: string;
  imageUrl: string;
}

export const OnboardingCarousel = ({
  handleHideModal,
}: {
  handleHideModal: (userHasSeenOnBoarding: boolean) => void;
}) => {
  const [error, setError] = useState<string>("");
  const [items, setItems] = useState<SlideItem[]>([]);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    fetch("/api/onboarding/1.0/content")
      .then((res) => res.json())
      .then(
        (result: SlideItem[]) => setItems(result),
        (error: string) => setError(error)
      );
  }, []);

  if (!error)
    return (
      <Slider {...settings}>
        {items.map((modalItem, index) => {
          return (
            <div key={index} className="onboarding-modal__content">
              <img
                className="onboarding-modal__image"
                src={modalItem.imageUrl}
                alt=""
              ></img>
              <h3 className="onboarding-modal__heading">{modalItem.heading}</h3>
              <div className="onboarding-modal__scrollable">
                <p className="onboarding-modal__description">
                  {modalItem.text}
                </p>
                {items.length === index + 1 && (
                  <button
                    className="onboarding-modal__button-done"
                    onClick={() => {
                      handleHideModal(false);
                    }}
                  >
                    Fortsätt till FAROnline
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </Slider>
    );
  else return null;
};
